import React, { Component } from "react";
import ClipLoader from "react-spinners/ClipLoader";

export default class MyLoader extends Component {
  render() {
    return (
      <div
        className="sweet-loading"
        style={{ width: "100%", textAlign: "center" }}
      >
        <ClipLoader
          color={"#4A90E2"}
          loading={true}
          size={40}
          sizeUnit={"px"}
        />
      </div>
    );
  }
}
